module.exports = __webpack_public_path__ + "img/ico-customer_products.250a727.svg";